import { render, staticRenderFns } from "./TemplateTrigger.vue?vue&type=template&id=6c2c7a1c&scoped=true&"
import script from "./TemplateTrigger.vue?vue&type=script&lang=js&"
export * from "./TemplateTrigger.vue?vue&type=script&lang=js&"
import style0 from "./TemplateTrigger.vue?vue&type=style&index=0&id=6c2c7a1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2c7a1c",
  null
  
)

export default component.exports